import { PageLayout } from '@bpm-web-app/components';
import { PlaylistDetail } from '@bpm-web-app/components/pages';

const PlaylistDetailPage = () => (
    <PageLayout>
        <PlaylistDetail />
    </PageLayout>
);

export default PlaylistDetailPage;
